import { render, staticRenderFns } from "./InvestigationRiskIndexDetail.vue?vue&type=template&id=71e2d167&scoped=true"
import script from "./InvestigationRiskIndexDetail.vue?vue&type=script&lang=js"
export * from "./InvestigationRiskIndexDetail.vue?vue&type=script&lang=js"
import style0 from "./InvestigationRiskIndexDetail.vue?vue&type=style&index=0&id=71e2d167&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71e2d167",
  null
  
)

export default component.exports